import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';

import { AiAgentEditComponent } from './ai-agent-edit/ai-agent-edit.component';
import { AiAgentsComponent } from './ai-agents/ai-agents.component';
import { AiSsistantSetupComponent } from './ai-ssistant-setup/ai-ssistant-setup.component';
import { AlcmeonAiComponent } from './alcmeon-ai/alcmeon-ai.component';
import { KnowledgeDocumentEditComponent } from './knowledge-document-edit/knowledge-document-edit.component';
import { KnowledgeDocumentsComponent } from './knowledge-documents/knowledge-documents.component';

@NgModule({
  declarations: [
    AiAgentEditComponent,
    AiAgentsComponent,
    AiSsistantSetupComponent,
    AlcmeonAiComponent,
    KnowledgeDocumentsComponent,
    KnowledgeDocumentEditComponent,
  ],
  imports: [CommonModule, SharedModule],
})
export class AlcmeonAiModule {}
